export const zindex = {
  header: 1000,
  dropdown: 1000,
  popover: 1060,
  tooltip: 1070,
  'navbar-fixed': 1030,
  'modal-background': 1040,
  modal: 1050,
}
